import { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import logo from '../Images/logo.png';
import { DashboardTopBar } from '../Components/DashboardTopBar';
import moneyplant from "../Images/moneyplant.png"
import { MiddleActionRow } from '../Components/MiddleActionRow';
import { RecentTransactions } from '../Components/RecentTransactions';
import { LatestActivity } from '../Components/LatestActivity';
import { useDispatch, useSelector } from 'react-redux';
import { UserProfile } from "../Components/UserProfile";
import { PlatformCards } from "../Components/Platforms";
import { PageHeader } from "../Components/HeaderBar";

import { AccountSectionTopInfoCard } from '../Components/AccountSection/AccountSectionTopInfoCard';
import { ToOpenAccount } from '../Components/AccountSection/ToOpenAccount';
import { LiveAccount } from '../Components/AccountSection/LiveAccount';
import { SupportTicket } from '../Components/SupportTicket/SupportTicket';
import { LogoutModal } from './LogoutModal';
import { logout } from '../Redux/Action/auth/logoutAction';
import { getPartnerAccountData, getUserdata } from '../Redux/Action';
import { WalletDeposit } from './WalletDepositSection';
import { AddedAccounts } from './AddedAccounts';
import { CommonButton } from '../Components/ui/CommonButton';
import { TradesOrder } from './TradesOrder';
import {
    FiMenu,
    FiChevronDown,
    FiChevronUp,
    FiHome,
    FiDollarSign,
    FiLogOut,
    FiTrendingUp,
    FiArrowDown,
    FiUser,
    FiChevronLeft,
    FiCalendar,
    FiHelpCircle,
    FiTerminal,
    FiList
} from 'react-icons/fi';
import { FaExchangeAlt, FaWallet } from 'react-icons/fa';
import { getLocalStorageItem } from '../Utils/Helper';
import { useTheme } from "next-themes";
import { useLocation, useNavigate } from 'react-router-dom';
import MainUserAccount from '../Components/AccountSection/MainUserAccount';
import AccountOverview from '../Components/AccountSection/AccountOverview';
import TradingOverview from '../Components/AccountSection/TradingOverview';
import { useAppTheme } from '../Hooks/useAppTheme';

export function MainPage() {
    const userData = useSelector((state) => state?.Login?.userData);
    const userDataLocalStorage= getLocalStorageItem("userData")
    const getActivityLoading = useSelector((state) => state?.GetUserActivity?.loading);
    const userRole = userData?.role;
    const location = useLocation();
    const navigate = useNavigate();
    const theme = useAppTheme();
    
    const tabs = [
        { key: 'dashboard', label: 'Dashboard' },
        { key: 'accounts', label: 'Manage Accounts',children: [

] },
        {
            key: 'financial', label: 'Financial', children: [
                { heading: 'Wallet' },
                { key: 'wallet-deposit-widthdraw', label: 'Deposit/Withdrawal' },

                { heading: 'MT5' },
                { key: 'mt5-deposit-widthdraw', label: 'Deposit/Withdrawal' },

            ]
        },
        { key: 'funds-activity', label: 'Funds Activity' },
        { key: 'trades-order', label: 'Trades Order' },
         { key: 'web-terminal', label: 'Web Terminal' },
        { key: 'transfer', label: 'Transfer' },
        { key: 'monitoring', label: 'Monitoring' },
        { key: 'calendar', label: 'Economic Calendar' },
        { key: 'platforms', label: 'Platforms' },
        { key: 'support', label: 'Support Ticket' },
        { key: 'profile', label: 'Profile' },
        { key: 'logout', label: 'Logout' },
    ];
    
    // Map routes to tab keys
    const routeToTabMap = useMemo(() => ({
        '/': 'dashboard',
        '/accounts': 'accounts',
        '/accounts/account-overview': 'account-overview',
        '/accounts/trading-overview': 'trading-overview',
        '/financial/wallet': 'wallet-deposit-widthdraw',
        '/financial/mt5': 'mt5-deposit-widthdraw',
        '/funds-activity': 'funds-activity',
        '/trades-order': 'trades-order',
        '/web-terminal': 'web-terminal',
        '/transfer': 'transfer',
        '/monitoring': 'monitoring',
        '/calendar': 'calendar',
        '/platforms': 'platforms',
        '/support': 'support',
        '/profile': 'profile'
    }), []);
    
    // Determine active tab based on current route
    const getActiveTabFromRoute = useCallback(() => {
        return routeToTabMap[location.pathname] || 'dashboard';
    }, [location.pathname, routeToTabMap]);
    
    const [activeTab, setActiveTab] = useState(getActiveTabFromRoute());
    const { resolvedTheme } = useTheme();
    const [openFinancial, setOpenFinancial] = useState(true);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [withdrawalAmount, setWithdrawalAmount] = useState()
    const dashBoardData = useSelector((state) => state?.GetDashboardData?.dashBoardData);
    const dispatch = useDispatch();
    const [selectedAccountType, setSelectedAccountType] = useState("live_account");
    const [refresh, setRefresh] = useState(false)
    const [partnerAccount, setPartnerAccount] = useState([])
    const [showLiveDepositAccountSection, setShowLiveDepositAccountSection] = useState(false)
    const [liveAccountDetails, setLiveAccountDetails] = useState()
    const whitelabelData = getLocalStorageItem("whitelabelData")
    // Ref for the web terminal iframe
    const webTerminalRef = useRef(null);

    // Update active tab when route changes
    useEffect(() => {
        setActiveTab(getActiveTabFromRoute());
        
        // Open financial section if wallet or mt5 routes are active
        if (location.pathname === '/financial/wallet' || location.pathname === '/financial/mt5') {
            setOpenFinancial(true);
        }
    }, [location, getActiveTabFromRoute]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1024) {
                setIsSidebarOpen(false);
            } else {
                setIsSidebarOpen(true);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    
    const logoSrc = (() => {
        if (whitelabelData) {
            if (!isSidebarOpen) {
                return whitelabelData?.logo_light || logo;
            } else {
                return resolvedTheme === "dark"
                    ? whitelabelData?.logo_dark || logo
                    : whitelabelData?.logo_light || logo;
            }
        } else {
            return isSidebarOpen ? logo : moneyplant;
        }
    })();
    
    const handleAccountTypeSelect = (type) => {
        setSelectedAccountType(type);
    };

    const fetchUserData = useCallback(() => {
        dispatch(getUserdata());
    }, [dispatch]);

    useEffect(() => {
        if (activeTab === "logout") {
            setShowLogoutModal(true);
        }
    }, [activeTab]);

    const getIbPartnerAccount = useCallback(() => {
        const referralCodeIb = {
            refferralCode: userData?.referralCode
        }
        dispatch(
            getPartnerAccountData({
                payload: referralCodeIb,
                callback: (data) => {
                    if (data?.code === 200) {
                        setPartnerAccount(data?.data)
                    } else {
                        // handle error
                    }
                },
            })
        );
    }, [userData?.referralCode, dispatch]);

    useEffect(() => {
        getIbPartnerAccount()
    }, [getIbPartnerAccount])

    useEffect(() => {
        fetchUserData()
        getIbPartnerAccount()
    }, [fetchUserData, getIbPartnerAccount, refresh])

    // Clear iframe session when user logs out (additional safeguard)
    useEffect(() => {
        const handleBeforeUnload = () => {
            if (webTerminalRef.current && activeTab === 'web-terminal') {
                try {
                    webTerminalRef.current.src = 'about:blank';
                } catch (e) {
                    console.warn('Could not clear iframe on unload:', e);
                }
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [activeTab]);

    // Additional cleanup when component unmounts or user logs out
    useEffect(() => {
        return () => {
            // Cleanup function when component unmounts
            if (webTerminalRef.current) {
                try {
                    webTerminalRef.current.src = 'about:blank';
                } catch (e) {
                    console.warn('Could not clear iframe on unmount:', e);
                }
            }
        };
    }, []);

    const handleTabChange = (tabKey) => {
        // Map tab keys to routes
        const tabToRouteMap = {
            'dashboard': '/',
            'accounts': '/accounts',
            'account-overview': '/accounts/account-overview',
            'trading-overview': '/accounts/trading-overview',
            'wallet-deposit-widthdraw': '/financial/wallet',
            'mt5-deposit-widthdraw': '/financial/mt5',
            'funds-activity': '/funds-activity',
            'trades-order': '/trades-order',
            'web-terminal': '/web-terminal',
            'transfer': '/transfer',
            'monitoring': '/monitoring',
            'calendar': '/calendar',
            'platforms': '/platforms',
            'support': '/support',
            'profile': '/profile'
        };
        
        const route = tabToRouteMap[tabKey];
        if (route) {
            navigate(route);
        } else if (tabKey === 'logout') {
            setShowLogoutModal(true);
        }
        
        if (['wallet-deposit', 'wallet-withdrawal', 'mt5-deposit', 'mt5-withdrawal'].includes(tabKey)) {
            setOpenFinancial(true);
        }
    };

    const handleLogoutClick = () => {
        // Clear iframe session immediately when logout is initiated
        if (webTerminalRef.current) {
            try {
                webTerminalRef.current.src = 'about:blank';
            } catch (e) {
                console.warn('Could not immediately clear iframe session:', e);
            }
        }
        setShowLogoutModal(true);
    };
    
    const handleDepositLiveAccount = (accountDetails, typefromCalled) => {
        if (typefromCalled === "mt5") {
            setShowLiveDepositAccountSection(true)
            setLiveAccountDetails(accountDetails)

        }
        else {
            navigate('/financial/mt5');
        }

    }

    const handleOpenLiveAccountTab = () => {
        navigate('/accounts');
    }
    
    const renderContent = () => {
        switch (activeTab) {
            case 'dashboard':
                return (
                    <>
                        <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="Dashboard" />
                        <DashboardTopBar onCardAction={handleTabChange} dashBoardData={dashBoardData} userData={userData} />
                        <MiddleActionRow setSelectedAccountType={setSelectedAccountType} userRole={userRole} setActiveTab={handleTabChange} />
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-8">
                            <RecentTransactions />
                            <LatestActivity getActivityLoading={getActivityLoading} userID={userDataLocalStorage?._id}/>
                        </div>
                    </>
                );
            case 'funds-activity':
                return (
                    <> <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="Funds Activity" />

                        <RecentTransactions />
                    </>
                );
            case 'accounts':
                return (
                    <>
                        <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="Manage Accounts" />
                        <AccountSectionTopInfoCard
                            onCardAction={handleTabChange}
                            dashBoardData={dashBoardData}
                            userData={userData}
                        />
                        {/* <MainUserAccount/> */}
                        
                        {
                            userData?.role === 6 && <ToOpenAccount whitelabelData={whitelabelData} selectedAccountType={selectedAccountType} setRefresh={setRefresh} onSelectAccountType={handleAccountTypeSelect} />
                        }


                        <div className="grid grid-cols-1 lg:grid-cols-1 my-2">
                            {selectedAccountType === 'live_account' && userRole !== 7 && (
                                <LiveAccount
                                    key={refresh}
                                   
                                    buttontext="Sync Now"
                                    contentWidth="w-full"
                                    buttonSize="sm"
                                    heading="Live Account"
                                    icon={<FaExchangeAlt />}
                                    ibAccounts={userData?.ibAccounts || []}
                                    otherData={userData}
                                    type="live_account"
                                    dwtype="accounts"
                                    handleDepositLiveAccount={handleDepositLiveAccount}

                                />
                            )}
                            {selectedAccountType === 'partner_account' && userRole !== 7 && (
                                <LiveAccount
                                    key={refresh}
                                    footerText="Join Now"
                                    buttontext="Sync Now"
                                    contentWidth="w-full"
                                    buttonSize="sm"
                                    heading="Partner Account"
                                    icon={<FaExchangeAlt />}
                                    userAccountData={partnerAccount || []}
                                    type="partner_account"
                                    dwtype="accounts"
                                    handleDepositLiveAccount={handleDepositLiveAccount}
                                />
                            )}
                        </div>
                    </>
                );

            case 'account-overview' : return <AccountOverview/>
            case 'trading-overview' : return <TradingOverview/>
            case 'wallet-deposit-widthdraw':
                return (
                    <>
                        <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="Wallet Deposit" />
                        <AccountSectionTopInfoCard activeTab={activeTab} withdrawalAmount={withdrawalAmount} onCardAction={handleTabChange} dashBoardData={dashBoardData} userData={userData} from="wallet-deposit" />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full mt-5">
                            <div className="w-full h-full">
                                <WalletDeposit dwtype="wallet" activeTab={activeTab} defaultPaymentType={"deposit"} withdrawalAmount={withdrawalAmount}
                                    setWithdrawalAmount={setWithdrawalAmount} setRefresh={setRefresh} refresh={refresh} />
                            </div>

                            <div className="w-full h-full">
                                <AddedAccounts refresh={refresh} />
                            </div>
                        </div>


                        <div className="grid grid-cols-1 gap-4 mt-8">
                            {<RecentTransactions defaultSet={["deposit"]} />}
                        </div>
                    </>
                );


            case 'mt5-deposit-widthdraw':
                return (
                    <>
                        <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="MT5 Deposit" />
                        <AccountSectionTopInfoCard refresh={refresh} withdrawalAmount={withdrawalAmount} onCardAction={handleTabChange} dashBoardData={dashBoardData} userData={userData} from="wallet-deposit" />
                        <div className="grid grid-cols-1 lg:grid-cols-1 my-2">

                            {
                              userData?.ibAccounts && userData?.ibAccounts.length === 0 && userRole === 6 && <>
                                    <h1 className="text-lg font-semibold">Live Accounts</h1>
                                    <CommonButton onClick={handleOpenLiveAccountTab} width="200px" text="Open Live Account" />
                                </>
                            }
                            {userRole !== 7 && (
                                <LiveAccount
                                    key={refresh}
                                   
                                    buttontext="Deposit/Widthdraw"
                                    contentWidth="w-full"
                                    buttonSize="sm"
                                    heading="Live Account"
                                    icon={<FaExchangeAlt />}
                                    ibAccounts={userData?.ibAccounts || []}
                                    otherData={userData}
                                    type="live_account"
                                    handleDepositLiveAccount={handleDepositLiveAccount}
                                    dwtype="mt5"
                                />
                            )}

                        </div>
                        {showLiveDepositAccountSection && <div className="flex flex-col lg:flex-row gap-6 w-full mt-5 items-stretch">

                            <div className="w-full lg:w-1/2">
                                <div className="h-full flex flex-col justify-end">
                                    <WalletDeposit setLiveAccountDetails={setLiveAccountDetails} dwtype="mt5" liveAccountDetails={liveAccountDetails} activeTab={activeTab} defaultPaymentType={"deposit"} withdrawalAmount={withdrawalAmount}
                                        setWithdrawalAmount={setWithdrawalAmount} setRefresh={setRefresh} refresh={refresh} />
                                </div>
                            </div>

                        </div>}

                    </>
                );

            case 'monitoring':
                return (
                    <>
                        <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="Monitoring Accounts" />
                    </>
                );

            case 'web-terminal':
                return (
                    <>
                        <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="Web Terminal" />
                        <div className="w-full h-[calc(100vh-180px)] rounded-lg overflow-hidden">
                            <iframe 
                                ref={webTerminalRef}
                                src="https://terminal.nexorfx.com/" 
                                title="Web Terminal"
                                className="w-full h-full border-0"
                                allow="fullscreen"
                            />
                        </div>
                    </>
                );

            case 'platforms':
                return (
                    <>
                        <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="Platforms" />
                        <PlatformCards />
                    </>
                );

            case 'support':
                return (
                    <>
                        <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="Support Ticket" />
                        <SupportTicket buttonSize="sm" buttontext="CREATE TICKET" />
                    </>
                );
                   case 'transfer':
                return (
                    <>
                        <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="Transfer" />
                       
                    </>
                );
                  case 'calendar':
                return (
                    <>
                        <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="Economic Calendar" />
                       
                    </>
                );
            case 'trades-order':
                return (
                    <>
                        <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="Trades Order" />
                        <TradesOrder />
                    </>
                );

            case 'profile':
                return (
                    <>
                        <PageHeader pageTitle={activeTab} onLogoutClick={handleLogoutClick} title="Profile" />
                        <UserProfile activeTab={activeTab}/>
                    </>
                );

            default:
                return <div>Select a tab to begin</div>;
        }
    };

    return (
        <div className="flex w-full min-h-screen overflow-x-hidden" style={{ backgroundColor: theme.bgPrimary }}>

            {/* Sidebar */}
            <nav
                className={`fixed top-0 left-0 h-screen ${isSidebarOpen ? 'w-64' : 'w-20'
                    } px-2 pt-4 flex flex-col z-50 transition-all duration-300 ease-in-out`}
                style={{ background: theme.brandGradient }}
            >
                {/* Expand/Collapse Toggle */}
                <div className="flex justify-end mb-4 px-2">
                    <button
                        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                        className="text-2xl"
                        style={{ color: theme.buttonPrimaryText }}
                    >
                        {isSidebarOpen ? <FiChevronLeft size={24} /> : <FiMenu size={24} />}
                    </button>
                </div>

                {/* Logo */}
                <div className="p-2 rounded mb-6 flex justify-center items-center h-16" style={{ backgroundColor: theme.bgCard }}>
                    <img
                        src={logoSrc}
                        alt="Logo"
                        className="transition-all duration-300 h-10"
                    />
                </div>

                {/* Tabs */}
                <div className="flex-1 space-y-2 overflow-auto">
                    {tabs.map((tab) => {
                        if (tab.key === 'financial') {
                            const filteredChildren =
                                userRole === 7 && userRole === 6
                                    ? tab.children.filter(
                                        (child) =>
                                            child.key !== 'wallet-deposit-widthdraw' &&

                                            child.heading !== 'MT5'
                                    )
                                    : tab.children;

                            return (
                                <div key={tab.key}>
                                    <button
                                        onClick={() => setOpenFinancial(!openFinancial)}
                                        className="w-full text-left py-2 px-3 rounded-lg text-sm font-medium flex items-center justify-between transition-all duration-300 hover:opacity-90"
                                        style={{
                                            backgroundColor: (activeTab.startsWith('wallet') || activeTab.startsWith('mt5')) ? theme.bgCard : 'transparent',
                                            color: (activeTab.startsWith('wallet') || activeTab.startsWith('mt5')) ? theme.brandPrimary : theme.iconText
                                        }}
                                    >
                                        <div className="flex items-center space-x-3">
                                            <FiDollarSign size={24} />
                                            {isSidebarOpen && <span>{tab.label}</span>}
                                        </div>
                                        {isSidebarOpen &&
                                            (openFinancial ? <FiChevronUp size={18} /> : <FiChevronDown size={18} />)}
                                    </button>

                                    {openFinancial && (
                                        <ul className={`mt-2 ${isSidebarOpen ? 'ml-4' : 'ml-2'} space-y-1`}>
                                            {filteredChildren.map((child, idx) => {
                                                if (child.heading) {
                                                    return isSidebarOpen ? (
                                                        <li
                                                            key={idx}
                                                            className="text-xs tracking-wide"
                                                            style={{ color: theme.textTertiary }}
                                                        >
                                                            {child.heading}
                                                        </li>
                                                    ) : null;
                                                } else {
                                                    const childIcons = {
                                                        'wallet-deposit-widthdraw': <FaWallet size={20} />,
                                                        'mt5-deposit-widthdraw': <FaExchangeAlt size={20} />,
                                                    };
                                                    
                                                    const childToRouteMap = {
                                                        'wallet-deposit-widthdraw': '/financial/wallet',
                                                        'mt5-deposit-widthdraw': '/financial/mt5'
                                                    };

                                                    return (
                                                        <li key={child.key}>
                                                            <button
                                                                title={!isSidebarOpen ? child.label : ''}
                                                                onClick={() => navigate(childToRouteMap[child.key] || '/')}
                                                                className="w-full text-left py-2 px-3 rounded-lg text-sm font-medium flex items-center space-x-3 transition-all duration-300 hover:opacity-90"
                                                                style={{
                                                                    backgroundColor: activeTab === child.key ? theme.bgCard : 'transparent',
                                                                    color: activeTab === child.key ? theme.brandPrimary : theme.iconText
                                                                }}
                                                            >
                                                                {childIcons[child.key] || <FaWallet size={20} />}
                                                                {isSidebarOpen && <span>{child.label}</span>}
                                                            </button>
                                                        </li>
                                                    );
                                                }
                                            })}

                                        </ul>
                                    )}
                                </div>
                            );
                        }

                        const tabIcons = {
                            dashboard: <FiHome size={24} />,
                            accounts: <FiUser size={24} />,
                            'funds-activity': <FiTrendingUp size={24} />,
                            'trades-order': <FiList size={24} />,
                            'web-terminal': <FiTerminal size={24} />,
                            transfer: <FaExchangeAlt size={24} />,
                            monitoring: <FiTrendingUp size={24} />,
                            calendar: <FiCalendar size={24} />,
                            platforms: <FiArrowDown size={24} />,
                            support: <FiHelpCircle size={24} />,
                            profile: <FiUser size={24} />,
                            logout: <FiLogOut size={24} />,
                        };

                        return (
                            <button
                                key={tab.key}
                                onClick={() => handleTabChange(tab.key)}
                                title={!isSidebarOpen ? tab.label : ''}
                                className="w-full text-left py-2 px-3 rounded-lg text-sm font-medium flex items-center space-x-3 transition-all duration-300 hover:opacity-90"
                                style={{
                                    backgroundColor: activeTab === tab.key ? theme.bgCard : 'transparent',
                                    color: activeTab === tab.key ? theme.brandPrimary : theme.iconText
                                }}
                            >
                                {tabIcons[tab.key] || <FiHome size={24} />}
                                {isSidebarOpen && <span>{tab.label}</span>}
                            </button>
                        );
                    })}
                </div>
            </nav>

            {/* Main Content */}
            <div
                className={`flex-1 transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-20'
                    } h-screen overflow-hidden`}
                style={{ backgroundColor: theme.bgPrimary }}
            >
                <div className="h-full overflow-auto p-4 sm:p-6">
                    {renderContent()}
                </div>
            </div>

            {/* Logout Modal */}
            <LogoutModal
                isOpen={showLogoutModal}
                onClose={() => {
                    setShowLogoutModal(false);
                    navigate('/');
                }}
                onConfirm={() => {
                 
                    if (webTerminalRef.current) {
                        try {
                      
                            webTerminalRef.current.src = 'about:blank';
                        } catch (e) {
                            console.warn('Could not clear iframe session:', e);
                        }
                    }
                    
                    dispatch(logout());
                    setShowLogoutModal(false);
                    
            
                    setTimeout(() => {
                        if (webTerminalRef.current) {
                            webTerminalRef.current.src = 'https://terminal.nexorfx.com/';
                        }
                    }, 500);
                }}
            />
        </div>
    );
}